// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity-mini[data-v-4ee502e2]{grid-template-columns:50px 140px 2fr minmax(0,auto)}", ""]);
// Exports
module.exports = exports;
